import { Object3D, Scene, type Object3DEventMap, EventDispatcher } from 'three';

/**
 * Scene with dispatcher
 * With this we can have scene.addEventListener on 'added' | 'removed'
 * and receive scene object updated
 */
class SceneWithDispatcher extends Scene {
    constructor() {
        super();
        Object.assign(this, EventDispatcher.prototype);
    }

    add(...object: Object3D<Object3DEventMap>[]) {
        const addedElement = super.add(...object);
        // @ts-expect-error: TypeScript does not recognize dispatchEvent on Scene
        (this as unknown as EventDispatcher).dispatchEvent({ type: 'added', object });
        return addedElement;
    }

    remove(...object: Object3D<Object3DEventMap>[]) {
        const removedElement = super.remove(...object);

        // @ts-expect-error: TypeScript does not recognize dispatchEvent on Scene
        (this as unknown as EventDispatcher).dispatchEvent({ type: 'removed', target: object });
        return removedElement;
    }
}

export { SceneWithDispatcher };
